module.exports = __webpack_public_path__ + "static/Banner-32-abe6127e8dc746c9bdec29e295baceeb.png";